import { Link } from "react-router-dom";
import Tm from "./Tm";

// Branded centered shell for the portal auth screens.
export default function PortalAuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen bg-brand-100 flex flex-col" data-testid="portal-auth-shell">
      <div className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="w-full max-w-md">
          <Link to="/" className="flex items-center gap-3 mb-10 justify-center" data-testid="portal-logo-link">
            <div className="w-10 h-10 bg-brand-700 text-white flex items-center justify-center font-serif text-xl leading-none">
              H
            </div>
            <div className="leading-tight">
              <div className="font-serif text-lg text-brand-700">Holder Hospitality</div>
              <div className="text-[10px] tracking-[0.25em] uppercase text-ink-muted -mt-0.5">Consulting</div>
            </div>
          </Link>
          <div className="bg-white border border-brand-200 p-8 lg:p-10">
            <div className="eyebrow mb-3">The Operator Walk<Tm /></div>
            <h1 className="font-serif text-3xl text-brand-700 leading-tight">{title}</h1>
            {subtitle && <p className="mt-3 text-ink-soft text-sm leading-relaxed">{subtitle}</p>}
            <div className="mt-8">{children}</div>
          </div>
          {footer && <div className="mt-6 text-center text-sm text-ink-muted">{footer}</div>}
        </div>
      </div>
    </div>
  );
}
